import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { AvSourcesDto } from '@/types/dtos/player/response/av-sources.dto';
import type { PlayerParentEntity } from '@/types/dtos/player/player-parent-entity';
import { GET_AV_SOURCES_QUERY_KEY } from '@/state/queries/players/use-get-av-sources';
import { GET_SPACE_PLAYER_SETUP_QUERY_KEY } from '@/state/queries/players/use-get-space-player-setup';

export type PutAvSourcesParams = {
  entityId: string;
  entityType: PlayerParentEntity;
  eventSlotId?: string | null;
  videoPlayerId: string | null;
  audioPlayerId: string | null;
  audienceVideoPlayerId?: string | null;
};

export const usePutAvSourcesMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: PutAvSourcesParams) => {
      const token = await getToken();
      return putAvSources(params, token ?? '');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_AV_SOURCES_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_SPACE_PLAYER_SETUP_QUERY_KEY] });
    },
  });
};

const putAvSources = async (params: PutAvSourcesParams, token: string): Promise<AvSourcesDto> => {
  const url = `${import.meta.env.VITE_API_URL}/player/av-sources`;
  return sendJSONRequest({ url, method: METHOD.PUT, body: params, token });
};
